module.exports = __webpack_public_path__ + "static/img/logo@2x.38168079.png";